import { ActionLogResponseDto } from "@/data/dto/super-admin/action-log-response-dto";
import { ActionLogInfoEntity } from "@/domain/entity/super-admin/action-log-info-entity";
import { assertActionLogResponseDto } from "@/utils/validation/generated/action-log-response-dto.validator";

export class ActionLogMapper {
  static toEntity(dto: ActionLogResponseDto): ActionLogInfoEntity {
    console.log("[ActionLogMapper] :: toEntity :: 입력 데이터:", JSON.stringify(dto, null, 2));
    assertActionLogResponseDto(dto);

    const list = dto.list.map((item) => ({
      code: item.code,
      eventType: item.eventType,
      eventAction: item.eventAction,
      component: item.component,
      parameter: item.parameter,
      pageScene: item.pageScene,
      occurredAt: item.occurredAt,
      occurredAtOffset: item.occurredAtOffset,
    }));

    return {
      totalCount: dto.totalCount,
      totalPage: dto.totalPage,
      list: list,
    };
  }
}
